<template>
  <div class="single-offer">
    <div class="row">
      <div class="col-12">
        <div class="togglebutton other mt-md-3 form-label-group">
          <label class="control-label">
            <!--<span>{{$t('message.contracts.type')}}</span><br><br>-->
            <input type="checkbox" v-model="no_changes" />
            <span class="toggle"></span>
            <span class="choise_2 text-nowrap">{{
              $t("message.contracts.offer_no_changes")
            }}</span>
          </label>
        </div>
      </div>
    </div>
    <div v-if="!no_changes">
      <div class="row">
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="offer_.discount_percents"
              :placeholder="
                $t('message.contracts.invoice_products_DiscountPercentage')
              "
              autocomplete="off"
              style="cursor: auto"
              id="discount_percents"
            />
            <label
              for="discount_percents"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.invoice_products_DiscountPercentage")
              }}</label
            >
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              payment_focused ? 'focused' : '',
            ]"
          >
            <v-select-popup
              type="payment_type"
              :placeholder="$t('message.contracts.payment_conditions')"
              v-model="offer_.payment_type"
            />
            <!-- <v-select id="contract_payment_type" :options="payment_types" label="display_text" :class="['form-control', offer_.payment_type.value!==''?'vs--selected':'']" @search="fetchPaymentType"  v-model="offer_.payment_type" :placeholder="$t('message.contracts.payment_conditions')" @focus="paymentFocused" @blur="paymentBlurred"></v-select>
	                    <label for="contract_payment_type" class="form-label-group-label shorter">{{$t('message.contracts.payment_conditions')}}</label> -->
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="offer_.discount_amount"
              :placeholder="$t('message.contracts.invoice_products_Discount')"
              autocomplete="off"
              style="cursor: auto"
              id="discount_amount"
            />
            <label
              for="discount_amount"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.invoice_products_Discount") }}</label
            >
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              delivery_focused ? 'focused' : '',
            ]"
          >
            <v-select-popup
              type="delivery_term"
              :placeholder="$t('message.contracts.conditions')"
              v-model="offer_.delivery_term"
            />

            <!-- <v-select id="contract_delivery_terms" :options="delivery_terms" label="display_text" :class="['form-control', offer_.delivery_term.value!==''?'vs--selected':'']" @search="fetchDeliveryTerms"  v-model="offer_.delivery_term" :placeholder="$t('message.contracts.conditions')" @focus="deliveryFocused" @blur="deliveryBlurred"></v-select>
	                    <label for="contract_delivery_terms" class="form-label-group-label shorter">{{$t('message.contracts.conditions')}}</label> -->
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="offer_.shipping_cost"
              :placeholder="$t('message.contracts.shipping_cost')"
              autocomplete="off"
              style="cursor: auto"
              id="shipping_cost"
            />
            <label for="shipping_cost" class="form-label-group-label shorter">{{
              $t("message.contracts.shipping_cost")
            }}</label>
          </span>
        </div>
        <div class="col-12">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <!-- <b-form-datepicker :locale="locale" v-model="offer_.contract_date" :placeholder="$t('message.contracts.contract_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="contract_date"></b-form-datepicker>
	                    <label for="contract_date" class="form-label-group-label shorter topped">{{$t('message.contracts.contract_date')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="offer_.contract_date = ' '"
              @blur="
                offer_.contract_date == ' '
                  ? (offer_.contract_date = '')
                  : (offer_.contract_date = offer_.contract_date)
              "
              inputClass="form-control"
              v-model="offer_.contract_date"
              :placeholder="$t('message.contracts.contract_date')"
              :inputAttr="{ id: 'contract_date' }"
            />
            <label
              for="contract_date"
              class="form-label-group-label shorter"
              :class="
                offer_.contract_date != '' && offer_.contract_date != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.contract_date") }}</label
            >
          </span>
        </div>
      </div>
      <!--<span :class="['bmd-form-group mb-1 d-block  form-label-group', country_focused?'focused':'']">
				 <v-select id="offers_search_country" :options="countries" label="display_text" :class="['form-control', typeof offer_.country !== 'undefined' && offer_.country.value!==''?'vs--selected':'']" @search="fetchCountries" @focus="countryFocus" @blur="countryBlur" v-model="offer_.country" :placeholder="$t('message.contracts.contragents_search_country')"></v-select>
				 <label for="offers_search_country" class="form-label-group-label shorter">{{$t('message.contracts.contragents_search_country')}}</label>
			</span>-->
      <!--<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
				<input type="text" class="form-control" v-model="offer_.name" :placeholder="$t('message.contracts.contragents_search_name')" autocomplete="off" style="cursor: auto;" id="single_offer_name">
				<label for="single_offer_name" class="form-label-group-label shorter">{{$t('message.contracts.contragents_search_name')}}</label>
			</span>-->
      <span :class="['bmd-form-group mb-2 d-block form-label-group ']">
        <textarea
          class="form-control"
          v-model="offer_.offer"
          :placeholder="$t('message.contracts.offer')"
          autocomplete="off"
          style="cursor: auto"
          id="single_offer_offer"
        ></textarea>
        <label
          for="single_offer_offer"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.offer") }}</label
        >
      </span>
      <!--<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
				<textarea class="form-control" v-model="offer_.products_description" :placeholder="$t('message.contracts.products_description')" autocomplete="off" style="cursor: auto;" id="single_offer_products"></textarea>-->
      <!--<label for="single_offer_country" class="form-label-group-label shorter">{{$t('message.contracts.offer')}}</label>-->
      <!--</span>-->
      <!--<span  :class="['bmd-form-group mb-2 d-block form-label-group']">
				<b-form-datepicker :locale="locale" v-model="offer_.valid_date" :placeholder="$t('message.contracts.offer_valid_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="single_offer_date"></b-form-datepicker>
			</span>-->
      <!--<span :class="['bmd-form-group mb-2 d-block form-label-group']">
				<input type="file" class="form-control" :placeholder="$t('message.contracts.document_file')" autocomplete="off" style="cursor: auto;" id="document_file" @change="fileSelected($event)">
				<label for="document_file" class="form-label-group-label shorter pb-0">{{$t('message.contracts.offer_file')}}</label>
			</span>-->
      <!--<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
				<textarea class="form-control" v-model="offer_.changes" :placeholder="$t('message.contracts.offer_changes')" autocomplete="off" style="cursor: auto;" id="single_offer_changes"></textarea>-->
      <!--<label for="single_offer_country" class="form-label-group-label shorter">{{$t('message.contracts.offer')}}</label>-->
      <!--</span>-->
      <div class="d-block files-block">
        <label>{{ $t("message.contracts.attachements") }}</label>
        <div class="file-o" v-for="(file, index) in offer_.files">
          <div class="row">
            <div class="col-11">
              <a target="_blank" :href="'/Picture/GetFile/' + file.id">{{
                file.name
              }}</a>
            </div>
            <div class="col-1">
              <button
                class="btn btn-sm btn-link text-danger"
                @click="deleteFile(file, index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-for="(file, index) in files_att" class="row">
          <div class="col-11">
            <input
              type="file"
              @change="attachFile($event, index)"
              class="form-control"
            />
          </div>
          <div class="col-1">
            <button
              class="btn btn-sm btn-link text-danger"
              @click="removeFile(index)"
            >
              &times;
            </button>
          </div>
        </div>
        <div>
          <button
            class="btn btn-sm btn-outline-success"
            @click="addAttachement"
          >
            {{ $t("message.contracts.add_attachement") }}
          </button>
          <br />
          <small
            ><i>{{ $t("message.contracts.add_attachement_info") }}</i></small
          >
        </div>
      </div>
    </div>
    <div v-else class="alert alert-warning rounded">
      {{ $t("message.contracts.offer_no_changes_message") }}
    </div>
    <b-button variant="success" @click="saveOffer" v-if="!no_changes">{{
      $t("message.add")
    }}</b-button>
    <b-button variant="success" @click="saveOfferSigned" v-else>{{
      $t("message.save_and_sign")
    }}</b-button>
  </div>
</template>
<script>
export default {
  props: {
    // offer: Object
  },
  data() {
    return {
      payment_types: [],
      delivery_terms: [],
      files_att: [],
      offer_: {
        name: "",
        country: {
          value: "",
        },
        offer: "",
        products_description: "",
        changes: "",
        files: [],

        payment_type: { value: "", display_text: "" },
        delivery_term: { value: "", display_text: "" },
        discount_percents: "",
        discount_amount: "",
      },

      no_changes: false,

      countries: [],
      country_focused: false,
      payment_focused: false,
      delivery_focused: false,
    };
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  mounted() {
    this.fetchCountries("");
    this.fetchCompany();
    this.fetchPaymentType("");
    this.fetchDeliveryTerms("");

    // this.offer_ = this.offer
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  methods: {
    attachFile(event, index) {
      if (typeof event.target.files[0] !== "undefined")
        this.files_att[index] = event.target.files[0];
    },
    removeFile(index) {
      this.files_att.splice(index, 1);
    },
    addAttachement() {
      this.files_att.push("");
    },
    deleteFile(file, index) {
      axios
        .get(window.base + "/Picture/DeleteFile/" + file.id)
        .then((response) => {
          this.offer_.files.splice(index, 1);
        });
    },
    deliveryFocused() {
      this.delivery_focused = true;
    },
    deliveryBlurred() {
      this.delivery_focused = false;
      // this.validateField('company_status')
    },
    fetchDeliveryTerms(search, loading) {
      this.getLibrary("delivery_term", search, 100);
    },
    fetchPaymentType(search, loading) {
      this.getLibrary("payment_type", search, 100);
    },
    fetchCompany() {
      if (this.$store.state.firmfull == false) {
        axios.get(window.base + "/document/getfirmfull").then((response) => {
          this.$store.commit("load_firm", response.data);
          this.current_company = response.data;
          if (
            typeof response.data.organizations !== "undefined" &&
            typeof response.data.organizations.org_name !== "undefined"
          )
            this.offer_.name = response.data.organizations.org_name;
          if (
            typeof response.data.organizations !== "undefined" &&
            typeof response.data.organizations.org_code !== "undefined"
          )
            this.offer_.bin = response.data.organizations.org_code;
          this.offer_.country = response.data.org_residency;
        });
      } else {
        this.current_company = this.$store.state.firmfull;
        if (
          typeof this.$store.state.firmfull.organizations !== "undefined" &&
          typeof this.$store.state.firmfull.organizations.org_name !==
            "undefined"
        )
          this.offer_.name = this.$store.state.firmfull.organizations.org_name;
        if (
          typeof this.$store.state.firmfull.organizations !== "undefined" &&
          typeof this.$store.state.firmfull.organizations.org_code !==
            "undefined"
        )
          this.offer_.bin = this.$store.state.firmfull.organizations.org_code;
        this.offer_.country = this.$store.state.firmfull.org_residency;
      }
    },
    saveOfferSigned() {
      var country = "";
      if (typeof this.offer_.country !== "undefined")
        country = this.offer_.country.value;

      var bodyFormData = new FormData();
      bodyFormData.set("attis_contract_id", this.$route.params.id);
      bodyFormData.set("discount_percents", this.offer_.discount_percents);
      bodyFormData.set("discount_amount", this.offer_.discount_amount);
      bodyFormData.set("payment_type", this.offer_.payment_type.value);
      bodyFormData.set("delivery_term", this.offer_.delivery_term.value);
      bodyFormData.set("contract_date", this.offer_.contract_date);
      bodyFormData.set("offer", this.offer_.offer);
      bodyFormData.set("shipping_cost", this.offer_.shipping_cost);
      bodyFormData.set("no_changes", true);

      this.files_att.forEach((i, ndx) => {
        bodyFormData.append("Files[" + ndx + "]", i);
      });

      axios({
        method: "post",
        url: window.base + "/contract/saveOfferSign",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        if (response.data == "ok") {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$t("message.message.offer-created"),
            timeout: 5000,
          }).show();
          this.$root.$emit("bv::hide::modal", "modal-offer-new", "#btnShow");
          this.$root.$emit("reloadOffers");
        } else {
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.message.offer-not-created") +
              " (" +
              response.data +
              ")",
            timeout: 5000,
          }).show();
        }
      });
    },
    saveOffer() {
      var country = "";
      if (typeof this.offer_.country !== "undefined")
        country = this.offer_.country.value;

      var bodyFormData = new FormData();
      bodyFormData.set("attis_contract_id", this.$route.params.id);
      bodyFormData.set("discount_percents", this.offer_.discount_percents);
      bodyFormData.set("discount_amount", this.offer_.discount_amount);
      bodyFormData.set("payment_type", this.offer_.payment_type.value);
      bodyFormData.set("delivery_term", this.offer_.delivery_term.value);
      bodyFormData.set("contract_date", this.offer_.contract_date);
      bodyFormData.set("offer", this.offer_.offer);
      bodyFormData.set("shipping_cost", this.offer_.shipping_cost);
      bodyFormData.set("no_changes", false);

      this.files_att.forEach((i, ndx) => {
        bodyFormData.append("Files[" + ndx + "]", i);
      });

      axios({
        method: "post",
        url: window.base + "/contract/saveOffer",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        if (response.data == "ok") {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$t("message.message.offer-created"),
            timeout: 5000,
          }).show();
          this.$root.$emit("bv::hide::modal", "modal-offer-new", "#btnShow");
          this.$root.$emit("reloadOffers");
        } else {
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.message.offer-not-created") +
              " (" +
              response.data +
              ")",
            timeout: 5000,
          }).show();
        }
      });
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    fileSelected(event) {
      if (typeof event.target.files[0] !== "undefined") {
        console.log(event.target.files[0]);
        if (event.target.files[0].size / 1000000 < 20)
          this.$set(this.offer_, "file", event.target.files[0]);
        else {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.contracts.file_too_big20"),
            timeout: 5000,
          }).show();
          document.querySelector("#document_file").value = "";
        }
      } else this.offer_.file = false;
    },
    paymentFocused() {
      this.payment_focused = true;
    },
    paymentBlurred() {
      this.payment_focused = false;
    },
  },
};
</script>
